import { useFloatingMenu } from 'articleEditor/hooks/useFloatingMenu';
import { MyEmbedElement } from 'lib-knowledge-document-structure/plateTypes';
import { RenderElementProps } from 'lib-knowledge-document-structure/slate/react';

import EmbedBlockPlaceholder from './embedBlockPlaceholder';
import EmbedBlockValue from './embedBlockValue';
import { EmbedLinkMenu } from './embedLinkMenu';

export type EmbedBlockProps = RenderElementProps & {
  element: MyEmbedElement;
};

function EmbedBlock({
  element,
  attributes,
  children,
}: EmbedBlockProps): JSX.Element {
  const linkMenu = useFloatingMenu();

  return (
    <div>
      {element.src ? (
        <EmbedBlockValue
          element={element}
          attributes={attributes}
          floatingLinkMenu={linkMenu}
        >
          {children}
        </EmbedBlockValue>
      ) : (
        <EmbedBlockPlaceholder
          element={element}
          attributes={attributes}
          floatingLinkMenu={linkMenu}
        >
          {children}
        </EmbedBlockPlaceholder>
      )}

      <EmbedLinkMenu element={element} floatingLinkMenu={linkMenu} />
    </div>
  );
}

export default EmbedBlock;
